export default __webpack_public_path__ + "728b984fb6f50d455514cd2a34da44ea.png";